import { render, staticRenderFns } from "./SnackbarNotification.vue?vue&type=template&id=c1613836&"
import script from "./SnackbarNotification.vue?vue&type=script&lang=js&"
export * from "./SnackbarNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports